import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import SelectInput from 'components/ui/forms/field/select-input/SelectInput'
import { EnrolState } from 'enum/enrol-state.enum'
import { useTranslationRankmi } from 'helpers/translations.helper'
import { prefix } from './constants'

interface Option {
  value: EnrolState
  label: string
}

interface FinalStateProps {
  value?: EnrolState
  onChange: (value?: Option | null) => void
}

export const FinalState = ({ value, onChange }: FinalStateProps) => {
  const { t } = useTranslation()
  const tRelative = useTranslationRankmi({
    prefix,
  })
  const options = useMemo<Option[]>(
    () => [
      {
        value: EnrolState.Pending,
        label: t(`administration.monitor.inProcess`),
      },
      {
        value: EnrolState.Approved,
        label: t(`administration.monitor.approved`),
      },
      {
        value: EnrolState.Denied,
        label: t(`administration.monitor.failed`),
      },
      {
        value: EnrolState.Absent,
        label: t(`administration.monitor.absent`),
      },
      {
        value: EnrolState.ExcusedAbsence,
        label: t(`administration.monitor.excusedAbsence`),
      },
    ],
    [t]
  )

  const selected = useMemo(
    () => options.find((option) => option.value === value),
    [options, value]
  )

  return (
    <SelectInput
      name="finalState"
      label={tRelative('finalState')}
      options={options}
      closeMenuOnSelect={true}
      value={selected}
      isMulti={false}
      onChange={onChange}
    />
  )
}

export default FinalState
